module.exports = __webpack_public_path__ + "assets/img/zyrw04.3d20aeff.png";